export default __webpack_public_path__ + "static/media/Versions - Comparisons_04.fe82597b.jpg";